import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Mail from '@wix/da-ds/pkg/Icons/24x24/Mail';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button from '../../../Button';
import VerificationEmailInput from '../../../VerificationEmailInput';
import verificationReminderStyles from './VerificationReminder.scss';
export var VerificationNeeded = function (_a) {
    var email = _a.email, resendEmail = _a.resendEmail, isEmailChangeInProgress = _a.isEmailChangeInProgress, isResendInProgress = _a.isResendInProgress, hideChangeEmail = _a.hideChangeEmail;
    var t = useTranslation().t;
    var isChangeInProgress = isEmailChangeInProgress || isResendInProgress;
    return (React.createElement("div", { className: verificationReminderStyles['root'] },
        React.createElement("div", { className: verificationReminderStyles['header'] },
            React.createElement(Mail, { className: verificationReminderStyles['message-icon'], size: IconSize.MEDIUM }),
            t('siteHeader.verification.verifyEmail.v2')),
        React.createElement("div", { className: verificationReminderStyles['text'] },
            React.createElement("p", null, t('siteHeader.verification.checkEmail.v2'))),
        React.createElement(Button, { isFakeButton: true, view: "b3", height: "medium", onClick: resendEmail, className: verificationReminderStyles['resend-button'], disabled: isChangeInProgress, forceHoverStateWhenDisabledBecauseReasons: isResendInProgress, fullWidth: false }, t(isResendInProgress
            ? 'siteHeader.verification.resending'
            : 'siteHeader.verification.resend')),
        React.createElement("div", { className: verificationReminderStyles['text-small'] },
            React.createElement(Trans, { i18nKey: "siteHeader.verification.notMe.v2" },
                "Not ",
                React.createElement("span", { className: verificationReminderStyles['user-email'] }, { email: email }),
                "?")),
        !hideChangeEmail && (React.createElement(VerificationEmailInput, { className: verificationReminderStyles['email-input'] }))));
};
VerificationNeeded.displayName = 'VerificationNeeded';
export default VerificationNeeded;
//# sourceMappingURL=VerificationNeeded.js.map